export interface IOAuthTokens {
  accessToken: string
  refreshToken: string
}

export const parseOAuthTokens = (hash: string): IOAuthTokens | null => {
  const params = new URLSearchParams(hash.replace(/^#/, ""))
  const accessToken = params.get("accessToken")
  const refreshToken = params.get("refreshToken")

  return accessToken && refreshToken ? { accessToken, refreshToken } : null
}
